var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print",on:{"click":_vm.printPage}},[_c('i',[_c('IconPrint')],1),_vm._v("\n  Artikel drucken\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }